var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarifIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71575 0 0 6.71575 0 15C0 23.2843 6.71575 30 15 30C23.2842 30 30 23.2843 30 15C30 6.71575 23.2842 0 15 0ZM15 3.25928C21.4842 3.25928 26.7389 8.5174 26.7389 15C26.7389 21.4826 21.4842 26.7389 15 26.7389C8.51575 26.7389 3.2611 21.4826 3.2611 15C3.26113 8.5174 8.51575 3.25928 15 3.25928ZM20.7477 7.8772L12.0538 16.5729L9.234 13.7531L6.46728 16.518L9.2871 19.3378L12.0721 22.1228L14.8371 19.3561L23.5327 10.6622L20.7477 7.8772Z",
    fill: "#2A73DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarifIcon);
export default __webpack_public_path__ + "static/media/tarif-icon.ddcce9a83f82539ab1a481e866eb7883.svg";
export { ForwardRef as ReactComponent };